import { createContext, FC, PropsWithChildren } from 'react'

export interface PreviewContextValue {
  body: string
  shortcodes: Array<{
    index: number
    category: string
    code: string
    params: Array<{
      key: string
      value: string | null
    }>
  }>
}

export const Context = createContext<PreviewContextValue | null>(null)

export const PreviewContextProvider: FC<
  PropsWithChildren<PreviewContextValue>
> = ({ children, body, shortcodes }) => {
  return (
    <Context.Provider value={{ body, shortcodes }}>{children}</Context.Provider>
  )
}
